/* eslint-disable camelcase */
export default class ProviderMapping {
  /**
   * Location Mapping entity for mapping PG location to PO location
   * @param {number} provider_id
   * @param {number} kareo_provider_id
   * @param {string} practice_id
   */
  constructor ({ provider_id, kareo_provider_id, practice_id }) {
    this.pgProviderId = provider_id
    this.poProviderId = kareo_provider_id
    this.pgPracticeUuid = practice_id
  }
}
